import { cardsService } from "./cardsService";
import { ICardResponse } from "./types";

export const suspendCard = async (cardId: string): Promise<ICardResponse> => {
  const { data } = await cardsService.post(`/${cardId}/suspend`);

  return data;
};
